import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';

class studentData{

    GetStudentData(StudentID){
        return axios.get(API_URL + `AR_StudentInfo/GetStudentData?StudentID=${StudentID}`,
            { headers: authHeader() } )            
      }

      GetPersonalData(StudentID){
        return axios.get(API_URL + `AR_StudentInfo/GetPersonalData?StudentID=${StudentID}`,
            { headers: authHeader() } )            
      }

      GetStudentActivityGrading(StudentID,CourseID,RoleReviewID){
        return axios.get(API_URL + `StudentGrading/GetStudentActivityGrading?StudentID=${StudentID}&CourseID=${CourseID}&RoleReviewID=${RoleReviewID}`,
        { headers: authHeader() } )   

      }

      SelectStudentTranscriptBySemester(StudentID,SemesterYearId){
        return axios.post(API_URL + `Transcript/SelectStudentTranscriptBySemester?StudentID=${StudentID}&SemesterYearId=${SemesterYearId}`,
        { headers: authHeader() } )   

      }


      SelectSTudentSemesterSummery(EnrollmentStudentId,StudentTransferDetails){
        return axios.post(API_URL + `Transcript/SelectSTudentSemesterSummery?EnrollmentStudentId=${EnrollmentStudentId}&StudentTransferDetails=${StudentTransferDetails}`,
        { headers: authHeader() } )   

      }

      getStudentScheduale(StudentID){
        return axios.get(API_URL + `StudentSchedule/GetStudentSchedule?StudentID=${StudentID}`,
        { headers: authHeader() } )    
              
    }

    GetStudentDebitChargesBasic(StudentID){
      return axios.get(API_URL + `Charges/GetStudentDebitChargesBasic?StudentID=${StudentID}`,
      { headers: authHeader() } )    
            
  }

 GetStudentDebitChargesAdvanced(StudentID,Payment_InstallmentID){
    return axios.get(API_URL + `Charges/GetStudentDebitChargesAdvanced?StudentID=${StudentID}&Payment_InstallmentID=${Payment_InstallmentID}`,
    { headers: authHeader() } )    
          
}

GetStudentCreditChargesBasic(StudentID){
  return axios.get(API_URL + `Charges/GetStudentCreditChargesBasic?StudentID=${StudentID}`,
  { headers: authHeader() } )    
        
}

GetStudentCurrentScholarship(StudentID){
  return axios.get(API_URL + `Scholarships/GetStudentCurrentScholarship?StudentID=${StudentID}`,
  { headers: authHeader() } )    
        
}

GetStudentHistoryScholarship(StudentID){
  return axios.get(API_URL + `Scholarships/GetStudentHistoryScholarship?StudentID=${StudentID}`,
  { headers: authHeader() } )    
        
}

GetStudentAccountDetails(StudentID,Currency){
  return axios.get(API_URL + `CashReceipts/GetStudentAccountDetails?StudentID=${StudentID}&CurrencyID=${Currency}`,
  { headers: authHeader() } )    
        
}

GetStudentTransactions(StudentID,PaymentMethodID,PaymentDate){
  return axios.get(API_URL + `CashReceipts/GetStudentTransactions?StudentID=${StudentID}&PaymentMethodID=${PaymentMethodID}&PaymentDate=${PaymentDate}`,
  { headers: authHeader() } )    
        
}

GetStudentTransactionsAdvanced(StudentID,PaymentDetailsID,IsCash,IsBank,IsTransfer,IsCheque,IsSystemTypeMethod){
  return axios.get(API_URL + `CashReceipts/GetStudentTransactionsAdvanced?StudentID=${StudentID}&PaymentDetailsID=${PaymentDetailsID}&IsCash=${IsCash}&IsBank=${IsBank}&IsTransfer=${IsTransfer}&IsCheque=${IsCheque}&IsSystemTypeMethod=${IsSystemTypeMethod}`,
  { headers: authHeader() } )    
        
}


GetStudentFinancialHistory(StudentID,DateFrom,DateTo,CreditOrDebit){
  return axios.get(API_URL + `CashReceipts/GetStudentFinancialHistory?StudentID=${StudentID}&DateFrom=${DateFrom}&DateTo=${DateTo}&CreditOrDebit=${CreditOrDebit}`,
  { headers: authHeader() } )    
        
}

    GetStudentBasicFinancialData(StudentID){
      return axios.get(API_URL + `CashReceipts/GetStudentBasicFinancialData?StudentID=${StudentID}`,
      { headers: authHeader() } )    
    
  }
  GetAcademicAdvice(StudentID ){
    return axios.get(API_URL + `AcademicAdvising/GetAcademicAdvice?StudentID=${StudentID}`,{

    },
    { headers: authHeader() } )
  }

  Student_Advises_Get(StudentID,SemesteryearID ){
    return axios.get(API_URL + `AcademicAdvising/Student_Advises_Get?StudentID=${StudentID}&SemesteryearID=${SemesteryearID}`,{

    },
    { headers: authHeader() } )
  }

  Student_Advises_Notes_Get(AdviseID){
    return axios.get(API_URL + `AcademicAdvising/Student_Advises_Notes_Get?AdviseID=${AdviseID}`,{

    },
    { headers: authHeader() } )
  }

  GetStudentState(StudentID,LevelID,SpecializationID){
    return axios.get(API_URL + `AcademicAdvising/GetStudentState?StudentID=${StudentID}&LevelID=${LevelID}&SpecializationID=${SpecializationID}`,{

    },
    { headers: authHeader() } )
  }

  GetCoursesForSelection(StudentID,FacultyId,SpecializationId,LevelID,CourseCode,CourseName,IsSelected){
    return axios.get(API_URL + `CurrentlyAchievedAcadimicLevel/GetCoursesForSelection?StudentID=${StudentID}&FacultyId=${FacultyId}&SpecializationId=${SpecializationId}&LevelID=${LevelID}&CourseCode=${CourseCode}&CourseName=${CourseName}&IsSelected=${IsSelected}`,{

    },
    { headers: authHeader() } )
  }

  GetFacultyLevels(FacultyID){
    return axios.get(API_URL + `StudentRegistration/GetFacultyLevels?FacultyID=${FacultyID}`,{

    },
    { headers: authHeader() } )
  }
  GetFacultySpecializations(FacultyID){
    return axios.get(API_URL + `StudentRegistration/GetFacultySpecializations?FacultyID=${FacultyID}`,{

    },
    { headers: authHeader() } )
  }


 
  SelectDeselectCourse(StudentID,FacultyId,SpecializationId,LevelID,CourseCode,CourseName,IsSelected,CourseId,SelectDeselect){
    return axios.post(API_URL + `CurrentlyAchievedAcadimicLevel/SelectDeselectCourse?StudentID=${StudentID}&FacultyId=${FacultyId}&SpecializationId=${SpecializationId}&LevelID=${LevelID}&CourseCode=${CourseCode}&CourseName=${CourseName}&IsSelected=${IsSelected}&CourseId=${CourseId}&SelectDeselect=${SelectDeselect}`,{

    },
    { headers: authHeader() } )
  }

  OnChangeGradeSelect(StudentID,FacultyId,SpecializationId,LevelID,CourseCode,CourseName,IsSelected,CourseId,GradeId){
    return axios.post(API_URL + `CurrentlyAchievedAcadimicLevel/OnChangeGradeSelect?StudentID=${StudentID}&FacultyId=${FacultyId}&SpecializationId=${SpecializationId}&LevelID=${LevelID}&CourseCode=${CourseCode}&CourseName=${CourseName}&IsSelected=${IsSelected}&CourseId=${CourseId}&GradeId=${GradeId}`,{

    },
    { headers: authHeader() } )
  }

  GetStudentUniversityOtherFaculties(StudentID ){
    return axios.get(API_URL + `Transfer_Advising/GetStudentUniversityOtherFaculties?StudentID=${StudentID}`,{

    },
    { headers: authHeader() } )
  }

  GetStudentEquivalentTransferTranscript(StudentID,FacultyID){
    return axios.get(API_URL + `Transfer_Advising/GetStudentEquivalentTransferTranscript?StudentID=${StudentID}&FacultyID=${FacultyID}`,{

    },
    { headers: authHeader() } )
  }


  // GET /api/CashReceipts/GetPaymentMethods
  GetPaymentMethods(){
    return axios.get(API_URL + `CashReceipts/GetPaymentMethods`,{

    },
    { headers: authHeader() } )
  }
  getStudentSchedualeNew(StudentID){
    return axios.get(API_URL + `StudentSchedule/StudentSchedule?StudentID=${StudentID}`,
    { headers: authHeader() } )    
          
}
GetAbsencePercentage(StudentID){
  return axios.get(API_URL + `StudentAttendance/GetAbsencePercentage?StudentID=${StudentID}`,
  { headers: authHeader() } )    
        
}
GetAbsenceWarnings(StudentID){
  return axios.get(API_URL + `StudentAttendance/GetAbsenceWarnings?StudentID=${StudentID}`,
  { headers: authHeader() } )    
        
}
GetCurrencies(){
  return axios.get(API_URL + `CashReceipts/GetCurrencies`,{

  },
  { headers: authHeader() } )
}
}



export default new studentData();